import onSelectionChange from '../events/onSelectionChange';
import selectNextRowInternal from '../internal/selectNextRowInternal';
import * as mailListSelectionActions from 'owa-mail-actions';
import { orchestrator } from 'satcheljs';
/////////////////////////////////////// PLEASE READ ///////////////////////////////////////////////////////////
// This is a top level selection action, as such, it should never call other top-level selection
// actions in the same directory, but only call into internal subdirectories where the core logic is implemented.
// This prevents double logging for CTQs as well as prevents onSelectionChange from being fired multiple times
// for a single user action.
///////////////////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * Select the next row
 * @param tableView where the operation is being performed
 * @param mailListItemSelectionSource selection mode for the maillist item
 */
export default orchestrator(mailListSelectionActions.selectNextRow, function (actionMessage) {
    var tableView = actionMessage.tableView;
    var mailListItemSelectionSource = actionMessage.mailListItemSelectionSource;
    selectNextRowInternal(tableView, mailListItemSelectionSource);
    // Propagate selection change event
    return onSelectionChange(tableView, true /* isUserNavigation */, mailListItemSelectionSource);
});
//# sourceMappingURL=selectNextRowOrchestrator.js.map